module.exports = __webpack_public_path__ + "static/media/icons@2x_1.3fd63997.png";